/**
 * This function returns comma separated number (in indian format)
 * @param value number to be converted
 * @param decimalPos (optional) number of decimals required
 */
export function toINR(value: any, decimalPos?: number) {
	// if value is not a number || undefined || null then return null
	// otherwise return the comma separated number
	// isNaN(Number(value)) handles the `undefined` case
	return value === null || isNaN(Number(value))
		? "--"
		: (Number(value) || 0).toLocaleString("en-IN", {
				maximumFractionDigits: decimalPos,
				minimumFractionDigits: decimalPos
		  });
}

//converts exp number
export function fullWide(x: string | number) {
	// let x: any = Number(y);
	return Number(x).toLocaleString("fullwide", { useGrouping: false });
}
